import React, { ReactElement, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserUnauthorized } from "pages/user-unauthorized/UserUnauthorized";
import { useAuth } from "shared/auth";
import { checkUnderMaintenance } from "shared/utils/helpers/checkMaintenance";

interface Props {
  roles: string[];
  children: ReactElement | ReactElement[];
  type: "route" | "component";
}

export const RouterGuard: React.FC<Props> = ({
  roles,
  children,
  type,
}: Props) => {
  const { authService } = useAuth();
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthorization = () => {
      const userRoles = authService.getUserRoles() || [];
      const isGenericUser = userRoles.some((role) =>
        ["TFE.generic"].includes(role),
      );

      setIsAuthorized(
        !isGenericUser || location.pathname === "/usuario_externo",
      );
    };

    checkAuthorization();
  }, [location.pathname]);

  if (isAuthorized === null) {
    return <></>;
  }

  if (!isAuthorized) {
    return <Navigate to="/usuario_externo" replace />;
  }

  const componentDefault = () => {
    return type === "component" ? <></> : <UserUnauthorized />;
  };

  const emailUser = authService.getUser()?.preferred_username || "";
  const isUnderMaintenance = checkUnderMaintenance(emailUser);

  if (isUnderMaintenance) {
    return <Navigate to="/mantenimiento" />;
  }

  return (
    <>
      {authService.isAuthenticated() &&
      authService.getUserRoles()?.some((x: any) => {
        return roles.includes(x);
      })
        ? children
        : componentDefault()}
    </>
  );
};

export default RouterGuard;
